import { render, staticRenderFns } from "./old-father-tree.vue?vue&type=template&id=7703de89&"
import script from "./old-father-tree.vue?vue&type=script&lang=js&"
export * from "./old-father-tree.vue?vue&type=script&lang=js&"
import style0 from "./old-father-tree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports